<script>
import { WithBreakpointComponent } from './breakpoints';
export default {
    mixins: [WithBreakpointComponent],
    data: () => ({
        currentSlide: 0,
        previousSlide: 5,
        lastSlideIndex: -1,
        movement: 'right'
    }),
    watch: {
        currentBreakpoint(newBreakpoint, oldBreakpoint) {
            this.refreshSlick();
        }
    },
    mounted() {
        this.$eventsBus.$on('slide-change', this.handleSlideChange);
    },
    beforeDestroy() {
        this.$eventsBus.$off('slide-change', this.handleSlideChange);
    },
    methods: {
        refreshSlick() {

        },
        handleSlideChange(slideEvent) {
            this.previousSlide = slideEvent.currentSlide;
            this.currentSlide = slideEvent.nextSlide;
            this.lastSlideIndex = slideEvent.numSlides - 1;
            if (Math.abs(slideEvent.nextSlide - slideEvent.currentSlide) === 1) {
                this.movement = (slideEvent.nextSlide - slideEvent.currentSlide > 0) ? 'right' : 'left';
            } else {
                this.movement = (slideEvent.nextSlide - slideEvent.currentSlide > 0) ? 'left' : 'right';
            }
        },
        scrollDown() {
            const carouselHeight = $(this.$el).height();
            const headerHeight = (this.currentBreakpoint === 'phone')
                ? 80 // Mobile header height
                : (this.currentBreakpoint === 'tablet')
                    ? 100 // Tablet header height
                    : 126; // Greater than tablet header height
            const offset = carouselHeight - headerHeight;
            $('html,body').animate({scrollTop: offset}, 600, 'swing');
        }
    }
};
</script>
